import React, {useCallback, useState} from "react";
import {FormControl,} from "@material-ui/core";
import SearchableSelect from "../../components/SearchableSelect";
import {InputType} from "../../common/FormRenderer";
import {
    CustomerTypeEnum,
    LocaleEnum,
    OrderStatus,
    RoleIdEnum,
    useCreateLogMutation,
    useGetUserListQuery,
    useUpdateOrderMutation,
} from "../../generated/graphql";
import NotificationPopup from "../../common/NotificationPopup";
import CreateView from "../custom/CreateView";
import {HasRole, selectMapFn, withCurrentOption} from "../../common/Util";
import {CurrencyList, InvoiceMethodList,} from "../../common/Constant";
import CreateContactView from "../contact/CreateContactView";
import CreateAdvertiserView from "../advertiser/CreateAdvertiserView";
import {useUser} from "../../Auth";

export default ({ order }) => {
    const user = useUser();
    const [advertiserId, setAdvertiserId] = useState<string | null>(
        order.advertiser?.id
    );
    const userListQuery = useGetUserListQuery({ fetchPolicy: "cache-and-network" });
    const [updateOrder] = useUpdateOrderMutation({
        refetchQueries: ["getOrder"],
    });
    const [createLog] = useCreateLogMutation();
    const createAdvertiserObject = {
        name: "createAdvertiserView",
        label: "廣告主",
        type: InputType.custom,
        renderCell:
            order.customer?.type == CustomerTypeEnum.Agent ? (
                <div style={{ marginTop: 10 }}>
                    <CreateAdvertiserView customer={order.customer} />
                    <FormControl style={{ width: "100%" }}>
                        <SearchableSelect
                            label={"廣告主"}
                            options={
                                order.customer?.advertisers.map(
                                    ({ id, name }) => ({
                                        value: id,
                                        label: name,
                                    })
                                ) ?? []
                            }
                            value={advertiserId}
                            onChange={(value) => {
                                setAdvertiserId(value);
                            }}
                        />
                    </FormControl>
                </div>
            ) : (
                <div />
            ),
    };
    const columns = order.status == OrderStatus.Draft
        ? [
            {
                name: "name",
                label: "專案名稱",
                value: order.name,
            },
            {
                name: "invoiceMethod",
                label: "發票開立方法",
                type: InputType.select,
                options: InvoiceMethodList,
                value: order.invoiceMethod,
            },
            createAdvertiserObject,
            {
                name: "createContactView",
                label: "新增聯絡人",
                type: InputType.custom,
                renderCell: order.customer ? (
                    <div
                        style={{
                            marginTop: 10,
                            marginBottom: 10,
                        }}
                    >
                        <CreateContactView
                            customer={order.customer}
                        />
                    </div>
                ) : (
                    <div />
                ),
            },
            {
                name: "contactId",
                label: "主要聯絡人",
                type: InputType.select,
                options: withCurrentOption(
                    (order.customer?.contacts ?? []).filter((c) => !c.disabled).map(selectMapFn),
                    order.contact,
                ),
                value: order.contact?.id,
            },
            {
                name: "invoiceContactId",
                label: "發票聯絡人",
                type: InputType.select,
                options: withCurrentOption(
                    (order.customer?.contacts ?? []).filter((c) => !c.disabled).map(selectMapFn),
                    order.invoiceContact,
                ),
                value: order.invoiceContact?.id,
            },
            {
                name: "currency",
                label: "幣別",
                type: InputType.select,
                value: order.currency,
                options: CurrencyList,
            },
            {
                name: "renewal",
                label: "續約",
                type: InputType.checkbox,
                value: order.renewal,
            },
            {
                name: "assignedSalesUserId",
                label: "負責人",
                type: InputType.select,
                value: order.assignedSalesUser?.id,
                options: withCurrentOption(
                    userListQuery.data?.users.map(selectMapFn) ?? [],
                    order.assignedSalesUser,
                ),
            },
            {
                name: "remark",
                label: "合約備註",
                value: order.remark,
                type: InputType.textarea,
            },
        ]
        : [
            createAdvertiserObject,
            {
                name: "createContactView",
                label: "新增聯絡人",
                type: InputType.custom,
                renderCell: order.customer ? (
                    <div
                        style={{
                            marginTop: 10,
                            marginBottom: 10,
                        }}
                    >
                        <CreateContactView
                            customer={order.customer}
                        />
                    </div>
                ) : (
                    <div />
                ),
            },
            {
                name: "invoiceContactId",
                label: "發票聯絡人",
                type: InputType.select,
                options: withCurrentOption(
                    (order.customer?.contacts ?? []).filter((c) => !c.disabled).map(selectMapFn),
                    order.invoiceContact,
                ),
                value: order.invoiceContact?.id,
            },
        ]
    const onSubmit = useCallback(
        async (updatedOrder, { resetForm }, setOpen) => {
            try {
                if (updatedOrder.currency) {
                    updatedOrder = {...updatedOrder, locale: updatedOrder.currency == "TWD" ?
                            LocaleEnum.ZhTw : LocaleEnum.EnUs}
                }
                if (advertiserId) {
                    updatedOrder = {...updatedOrder, advertiserId}
                }
                const newOrder = await updateOrder({
                    variables: {
                        order: updatedOrder,
                        id: order.id,
                    },
                });
                NotificationPopup.success(`修改完成`);
                setOpen(false);
                return newOrder.data?.updateOrder;
            } catch (e) {
                NotificationPopup.error(`修改委刊單發生問題: ${e.message}`);
                console.error(e);
            }
        },
        [updateOrder, advertiserId, user]
    );

    return (
        <HasRole roles={[RoleIdEnum.Ae, RoleIdEnum.Pm, RoleIdEnum.Admin]}>
            <CreateView
                title={"修改委刊單"}
                columns={columns}
                onSubmit={onSubmit}
                submitTitle={"修改"}
                queryEntity={"order"}
            />
        </HasRole>
    );
};
